export function openTelegramLink(directPayLink: string) {
  Telegram.WebApp?.openTelegramLink(directPayLink);
  // if (Telegram.WebApp.platform === 'android') {
  //   window.location.reload();
  //   window.location.replace(window.location.pathname);
  // }
}
